// extracted by mini-css-extract-plugin
export default {"actions":"Encuesta_actions__FfC8u","download":"Encuesta_download__uajLk"};